/**
 * Renders the Multi Select
 */
import {
  ControlProps,
  RankedTester,
  rankWith,
  Test,
  UISchemaElement,
} from '@jsonforms/core';
import { useJsonForms, withJsonFormsOneOfEnumProps } from '@jsonforms/react';
import _ from 'lodash';
import React from 'react';

import { InputMultiSelect } from '../spectrum-control/InputMultiSelect';
import { SpectrumInputControl } from './SpectrumInputControl';
import {
  convertTitleConstToLabelValue,
} from '../util/commonUtils';

export const SpectrumMultiSelectControl = (props: ControlProps) => {
  const context = useJsonForms();
  const config = context.config;

  const uischema = props.uischema;
  const schema: any = props.schema;

  const dataSource = uischema.options?.dataSource;
  const name = uischema.options?.name;

  const transformData = config?.lifecycleHooks?.multiSelect?.transformData;

  if (!dataSource) {
    console.error('dataSource is not defined in the uischema.options');
  }

  let options = [];

  switch (dataSource.type) {
    case 'context':
      const contextKey = dataSource.value;
      if (!contextKey) {
        console.error(
          'Context key is not defined in the uischema.options.dataSource'
        );
      }
      const pageContext = config.pageContext;

      const contextData = _.get(pageContext, contextKey);

      if (!contextData) {
        console.error(`contextData for key '${contextKey}' does not exists`);
        return null;
      }

      if (transformData) {
        options = transformData(name, contextData);
      } else {
        options = contextData;
      }

      break;
    case 'static':
      if (schema?.items?.oneOf) {
        options = convertTitleConstToLabelValue(schema.items.oneOf);
      }

      break;
    default:
      console.error('dataSource.type is not defined in the uischema.options');
  }

  return (
    <SpectrumInputControl {...props} options={options} input={InputMultiSelect} />
  );
};

const { and, } = Test;

const isMultiSelectTrue: Test.Tester = (uischema: UISchemaElement) => {
  return uischema?.options?.multiSelect;
}

// const isDataSourceStatic: Test.Tester = (uischema: UISchemaElement) =>
//   uischema?.options?.dataSource?.type === 'static';

// const isDataSourceContext: Test.Tester = (uischema: UISchemaElement) =>
//   uischema?.options?.dataSource?.type === 'context';

export const spectrumMultiSelectControlTester: RankedTester = rankWith(
  6,
  and(
    isMultiSelectTrue,
    // or(
    //   and(isDataSourceStatic, or(isEnumControl, isOneOfEnumControl)),
    //   isDataSourceContext
    // )
  )
);

export default withJsonFormsOneOfEnumProps(SpectrumMultiSelectControl);
